import { Hotel } from 'tokyu-hooks'

export const QUERY_CANCELLATION_POLICIES_KEY = 'QUERY_CANCELLATION_POLICIES_KEY'

export const fetchCancellationPolicies =
  (clientSession: string, _?: string) =>
  async ({ queryKey }: { queryKey: any[] }) => {
    const [_key, { hotelCode, locale, roomPlanCodes }] = queryKey

    if (!hotelCode) return null

    const res = await Hotel.cancellationPolicies({
      baseUrl: process.env.NEXT_PUBLIC_TRIPLA_BASE_URL as string,
      clientSession,
      hotelCode,
      locale,
      room_plan_codes: roomPlanCodes,
    })

    return res?.data ?? null
  }
